import React from 'react';
import './MissionVision.css';

const MissionVision = () => {
  return (
    <>

      <section className="mv-container">
        <div className="mv-card">
          {/* Adornos diagonales en las esquinas */}
          <div className="corner-decor top-left"></div>
          <div className="corner-decor bottom-right"></div>

          {/* Encabezado / Branding */}
          <header className="mv-header">
            <div className="brand-section">
              <div className="red-cross-icon">+</div>
              <div className="brand-text">
                <span className="brand-title">Cruz Roja Colombiana</span>
                <span className="brand-subtitle">Seccional Sucre</span>
              </div>
            </div>

            <div className="header-divider"></div>

            <div className="institute-section">
              <span className="institute-prefix">Instituto de</span>
              <h2 className="institute-title">Educación</h2>
            </div>
          </header>

          {/* Contenido: Misión y Visión */}
          <div className="mv-content">
            {/* Columna Misión */}
            <article className="mv-column">
              <h3 className="mv-title">MISIÓN</h3>
              <p className="mv-text">
                Somos una Institución Educativa de la Cruz Roja Colombiana Seccional Sucre,
                comprometida con la calidad y guiada por nuestros principios institucionales.
                Fortalecemos las capacidades comunitarias y promovemos la construcción de paz,
                la inclusión social, la adaptación al cambio climático, la educación y los derechos humanos.
                Nos dedicamos a contribuir al proceso de formación integral y permanente de voluntarios,
                empleados, directivos y estudiantes, impactando de manera positiva a la comunidad en general.
              </p>
            </article>

            {/* Columna Visión */}
            <article className="mv-column">
              <h3 className="mv-title">VISIÓN</h3>
              <p className="mv-text">
                Para el año 2027, el Instituto de Educación de la Cruz Roja Colombiana Seccional Sucre
                será una institución humanitaria, inclusiva y sostenible, reconocida a nivel departamental
                por su liderazgo, calidad y pertinencia en la oferta de servicios educativos.
                Se destacará por su excelencia e innovación, así como por su contribución a la cultura,
                la paz y la reconciliación. Además, fortalecerá la resiliencia de las poblaciones más
                vulnerables y promoverá el respeto y la defensa de los Derechos Humanos y del Derecho
                Internacional Humanitario, manteniendo coherencia con el perfil integral establecido
                para voluntarios, empleados, directivos y estudiantes de la comunidad en general.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="nuestro-equipo">
  <div className="nuestro-equipo__header">
    <span className="nuestro-equipo__badge">Comunidad & Talento</span>
    <h1 className="nuestro-equipo__title">Nuestro Equipo</h1>
    <p className="nuestro-equipo__subtitle">
      Nuestro equipo está conformado por personas que entienden que la educación va más allá del aula. 
      Son profesionales que escuchan, orientan y construyen junto a ti un camino de aprendizaje significativo. 
      Cada integrante representa un pilar en nuestra misión de acompañarte con excelencia, calidez y responsabilidad, 
      contribuyendo al desarrollo técnico, humano y espiritual de nuestra comunidad.
    </p>
  </div>

  <div className="nuestro-equipo__card">
    <div className="nuestro-equipo__card-accent"></div>
    <p className="nuestro-equipo__card-text">
      Cada miembro aporta una combinación única de experiencia, vocación y compromiso que se refleja en el acompañamiento 
      que ofrecemos. Nos une el propósito de formar, inspirar y apoyar a cada estudiante en su proceso de crecimiento. 
      Desde instructores técnicos hasta asesores vocacionales, desde diseñadores pedagógicos hasta líderes comunitarios, 
      todos compartimos la convicción de que el aprendizaje transforma vidas. Confía en que detrás de cada clase, 
      cada orientación y cada proyecto, hay personas dedicadas que creen en tu potencial y trabajan para que tengas éxito.
    </p>
  </div>
</section>

    </>
  );
};

export default MissionVision;